import { config } from "Utils/config"

export const initScript = () => {
  return new Promise(resolve => {
    let isLoaded = false

    let doc = document.createElement("script")
    doc.type = "text/javascript"
    doc.src = `https://maps.googleapis.com/maps/api/js?key=${config.GOOGLE_MAP}&libraries=places,geometry`

    const script = document.getElementsByTagName("script")

    for (let sc of script) {
      if (sc.src.indexOf(config.GOOGLE_MAP) !== -1) {
        isLoaded = true
      }
    }

    if (!isLoaded) {
      script[0].parentNode.insertBefore(doc, script[0])
    }

    const checkInterval = setInterval(() => {
      if (window.google) {
        clearInterval(checkInterval)
        return resolve(true)
      }
    }, 1000)
  })
}
